import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth_page/Login';
import Dashboard from './components/pages/Dashboard';
import routes from './routes';
import { useNavigate } from 'react-router-dom';
import { getUserData } from './components/constants';
import ProtectedRoute from './components/protectedRoute';
import DesktopLayout from './components/desktopLayout';

const App = () => {
  const isAuthenticated = localStorage.getItem('token');
  const navigate = useNavigate();
  // console.log(getUserData());
  const renderRoutes = (routes) =>
    routes.map((route) => {
      if (route.children) {
        return (
          <Route key={route.key} path={route.path} element={""}>
            {renderRoutes(route.children)}
          </Route>
        );
      }
      return (
        <Route
          key={route.key}
          path={route.path}
          element={route.component ? <route.component /> : <div>{route.label} Page</div>}
        />
      );
    });

  return (
    <Routes>
      {!isAuthenticated ? (
        <Route path="*" element={<Navigate to="/login" />} />
      ) : (
        <Route path="/" element={
          // <DesktopLayout>
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          // </DesktopLayout>
        }>
          {renderRoutes(routes)}
        </Route>
      )}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <Login />} />
    </Routes>
  );
};

export default App;
